var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "text-md-center container-fluid",
    class: _vm.payloadInterface.primarySlice.background_color ? 'layout-with-background' : 'layout-without-background',
    style: {
      backgroundColor: _vm.payloadInterface.primarySlice.background_color
    }
  }, [_c('div', {
    staticClass: "col-11 col-md-8 mx-auto mb-md-4 mb-sm-3"
  }, [_vm.payloadInterface.primarySlice.title[0].text ? _c('regular-title', {
    attrs: {
      "text": _vm.payloadInterface.primarySlice.title[0].text,
      "level": _vm.payloadInterface.primarySlice.title[0].type
    }
  }) : _vm._e(), _vm._v(" "), _vm.payloadInterface.primarySlice.paragraph.length > 0 ? _c('simple-paragraph', {
    staticClass: "text-md-center mb-2",
    attrs: {
      "paragraph": _vm.payloadInterface.primarySlice.paragraph
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pricing-plan-list mt-sm-3"
  }, _vm._l(_vm.payloadInterface.items, function (item) {
    return _c('div', {
      key: item.image.small,
      staticClass: "item"
    }, [_c('pricing-plan', {
      staticClass: "mx-3 mx-lg-0",
      attrs: {
        "header": item.header,
        "header-bg-color": item.headerBgColor,
        "title": item.title,
        "subtitle-rich": item.subtitleRich,
        "price": item.basePrice,
        "subprice": item.subprice,
        "subprice-strike": item.subpriceStrike,
        "image": item.image,
        "cta": item.cta,
        "ctatheme": item.cta_theme,
        "link": item.link,
        "paragraph-title": item.paragraphTitle,
        "paragraph": item.paragraph,
        "tracking": item.tracking
      }
    })], 1);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };